import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DEFAULT_PAGE_SIZES } from '~/src/components/common-components/pagination/components/page-limiter/page-limiter.constants';
import {
    AgentsLeadsFilterParamsState,
    AgentsLeadsListState,
} from '~/src/redux/agents-leads-filter-params/agents-leads-filter-params.types';

const initialState = new AgentsLeadsListState();

const AgentsLeadsListSlice = createSlice({
    name: 'agents-leads-list',
    initialState,
    reducers: {
        setAgentsLeadsFilterParams: (
            state,
            action: PayloadAction<{ updateFilter: AgentsLeadsFilterParamsState; statusFilter: boolean }>,
        ) => {
            return {
                ...state,
                filter: action.payload.updateFilter,
                currentPage: 1,
                isActiveFilter: action.payload.statusFilter,
            };
        },
        clearAgentsLeadsFilterParams: (state) => {
            return { ...state, filter: new AgentsLeadsFilterParamsState(), currentPage: 1, isActiveFilter: false };
        },
        setCurrentPage: (state, action: PayloadAction<number>) => {
            return { ...state, currentPage: action.payload };
        },
        setCurrentPageSize: (state, action: PayloadAction<number>) => {
            return { ...state, currentPageSize: action.payload };
        },
        clearPaginationParams: (state) => {
            return { ...state, currentPageSize: DEFAULT_PAGE_SIZES[0], currentPage: 1 };
        },
        clearAgentsLeadsList: () => {
            return new AgentsLeadsListState();
        },
    },
});

export const {
    setAgentsLeadsFilterParams,
    clearAgentsLeadsFilterParams,
    setCurrentPage,
    setCurrentPageSize,
    clearPaginationParams,
    clearAgentsLeadsList,
} = AgentsLeadsListSlice.actions;

export const AgentsLeadsFilterParamsReducer = AgentsLeadsListSlice.reducer;
